import { __exports as exceptions } from "./index152.js";
var hasRequiredExceptions;
function requireExceptions() {
  if (hasRequiredExceptions) return exceptions;
  hasRequiredExceptions = 1;
  Object.defineProperty(exceptions, "__esModule", {
    value: true
  });
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }
  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  var InvalidInputException = (function(_Error) {
    _inherits(InvalidInputException2, _Error);
    function InvalidInputException2(symbology, input) {
      _classCallCheck(this, InvalidInputException2);
      var _this = _possibleConstructorReturn(this, (InvalidInputException2.__proto__ || Object.getPrototypeOf(InvalidInputException2)).call(this));
      _this.name = "InvalidInputException";
      _this.symbology = symbology;
      _this.input = input;
      _this.message = '"' + _this.input + '" is not a valid input for ' + _this.symbology;
      return _this;
    }
    return InvalidInputException2;
  })(Error);
  var InvalidElementException = (function(_Error2) {
    _inherits(InvalidElementException2, _Error2);
    function InvalidElementException2() {
      _classCallCheck(this, InvalidElementException2);
      var _this2 = _possibleConstructorReturn(this, (InvalidElementException2.__proto__ || Object.getPrototypeOf(InvalidElementException2)).call(this));
      _this2.name = "InvalidElementException";
      _this2.message = "Not supported type to render on";
      return _this2;
    }
    return InvalidElementException2;
  })(Error);
  var NoElementException = (function(_Error3) {
    _inherits(NoElementException2, _Error3);
    function NoElementException2() {
      _classCallCheck(this, NoElementException2);
      var _this3 = _possibleConstructorReturn(this, (NoElementException2.__proto__ || Object.getPrototypeOf(NoElementException2)).call(this));
      _this3.name = "NoElementException";
      _this3.message = "No element to render on.";
      return _this3;
    }
    return NoElementException2;
  })(Error);
  exceptions.InvalidInputException = InvalidInputException;
  exceptions.InvalidElementException = InvalidElementException;
  exceptions.NoElementException = NoElementException;
  return exceptions;
}
export {
  requireExceptions as __require
};
//# sourceMappingURL=index120.js.map
